let copartner = [
    {
        path: 'copartner',
        name: '合伙人管理',
        component: () => import("@/views/sellerAdmin/marketing/wares/index.vue"),
        children: [
            {
                path: 'shoplabel',
                component: () => import("@/views/admin/affluent/copartner/shoplabel/index.vue"),
                name: '合伙人标签',
                meta: {
                    hidden: true,
                    key:20004
                },
            },
            {
                path: 'ka',
                component: () => import("@/views/admin/affluent/copartner/ka/index.vue"),
                name: 'KA合伙人(门店/商家)',
                meta: {
                    hidden: true,
                    key:20001,
                    type:0
                },
            },
            {
                path: 'town',
                component: () => import("@/views/admin/affluent/copartner/ka/index.vue"),
                name: '村镇合伙人(一村一网点)',
                meta: {
                    hidden: true,
                    key:20002,
                    type:1
                },
            },
            {
                path: 'urban-district',
                component: () => import("@/views/admin/affluent/copartner/ka/index.vue"),
                name: '城区合伙人(分销)',
                meta: {
                    hidden: true,
                    key:20003,
                    type:2
                },
            },
            {
                path: 'logistics',
                component: () => import("@/views/admin/affluent/copartner/logistics/index.vue"),
                name: '物流合伙人(配送推单)',
                meta: {
                    hidden: true,
                },
            },

            {
                path: 'supplier-list',
                component: () => import("@/views/admin/affluent/copartner/supplier-list/index.vue"),
                name: '供应商管理',
                meta: {
                  hidden: true,
                  key: 'system',
                },
              },
              {
                path: 'village',
                component: () => import("@/views/admin/affluent/copartner/village/index.vue"),
                name: '村委管理',
                meta: {
                    hidden: true,
                    key:20004
                },
            },
        ]
    }
]




export const affluent = [
    {
        path: '/affluent',
        name: '共同富裕系统',
        component: () => import("@/views/layout/index.vue"),
        children: [
            ...copartner,//合伙人
        ]
    },

]
